import { Suspense } from 'react'

import LanguageSelector from './LanguageSelector'
import useTranslations from '../../../hooks/useTranslations'
import { ANTDFooter, ANTDHeader } from '../../../shared/antd/ANTDLayout'
import ANTDSpin from '../../../shared/antd/ANTDSpin'
import configData from '../../../utils/config'

const PublicLayout = ({ children }) => {
  const { t } = useTranslations()
  const { logo } = configData

  return (
    <>
      <ANTDHeader className="d-flex bg-primary-color space-between">
        <div className="d-flex align-center">
          <img
            src={logo}
            alt="Mat Next"
            height="55px"
            width="auto"
            style={{
              position: 'absolute',
              left: '0px',
              padding: '5px',
              background: 'white',
            }}
          />
        </div>
        <div className="align-center">
          <LanguageSelector />
        </div>
      </ANTDHeader>
      <Suspense
        fallback={
          <div className="lazy-loader">
            <ANTDSpin size="large" />
            <span>{t('txt_Loading')}</span>
          </div>
        }
      >
        <div className="public-layout">{children}</div>
      </Suspense>
      <ANTDFooter className="footer">
        <span>©{new Date().getFullYear()} GenbaNEXT Limited</span>
      </ANTDFooter>
    </>
  )
}

export default PublicLayout
